import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Checkbox, ListItem, ListItemIcon, ListItemText, Popover, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import DashboardFuncionalidade from "app/Core/Components/DashboardFuncionalidade/DashboardFuncionalidade";
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import PesquisaPainel from "app/Core/Components/PesquisaPainel/PesquisaPainel";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import EmpresaPessoaApp from "app/ERP/EmpresaPessoa/EmpresaPessoaApp";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import queryString from "query-string";
import React from "react";
import { GiFire } from "react-icons/gi";
import { MdDone, MdLabel, MdToday } from "react-icons/md";
import { RiTimerLine } from "react-icons/ri";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import NovoFluxoApp from "../../Workflow/MinhasTarefas/Apps/NovoFluxoApp";
import EmpresaFinanceiroBaixaDialog from "./Dialog/EmpresaFinanceiroBaixaDialog";
import EmpresaFinanceiroDetalheDialog from "./Dialog/EmpresaFinanceiroDetalheDialog";
import EmpresaFinanceiroGrupoDialog from "./Dialog/EmpresaFinanceiroGrupoDialog";
import EmpresaFinanceiroTituloDialog from "./Dialog/EmpresaFinanceiroTituloDialog";
import * as Actions from "./Store/Actions/EmpresaFinanceiroActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = () => ({
    footer: {
        display: "flex",
        position: "fixed",
        right: 30,
        bottom: 50,
        zIndex: 99
    },
    tachado: {
        textDecoration: "line-through"
    },
});

const parametros = {
    tipo: 1,
    filter: {
        AND: [{ "Campo": "natureza", "Operador": "IN", "Valor": "(1, 14)" },
        { "Campo": "validacao", "Operador": "IS NOT", "Valor": "null" },
        { "Campo": "tarefaprocessoapontamentoitem.vencimento", "Operador": ">=", "Valor": (Helpers.GetDataFirstDayMonth("usa") + " 00:00:00") },
        { "Campo": "tarefaprocessoapontamentoitem.vencimento", "Operador": "<=", "Valor": (Helpers.GetDataLastDayMonth("usa") + " 23:59:59") },
        { "Campo": "tarefaprocessoapontamentoitem.valor", "Operador": ">", "Valor": "0" },
        { "Campo": "tarefaprocessoapontamentoitem.statusregistro", "Operador": "=", "Valor": "1" }]
    }
};

const NewState = {
    inicio: Helpers.GetDataFirstDayMonth("usa"),
    termino: Helpers.GetDataLastDayMonth("usa"),
    idpessoaformulario: null,
    idtarefaprocessoapontamentoitem: null,
    nome: null,
    open: null,
    openGrupo: null,
    openDetalhe: null,
    openTitulo: null,
    selecteds: "",
    rowId: null,
    forceRefresh: 0
};

class EmpresaFinanceiroPagar extends XAPPComponent {

    state = { ...NewState };

    componentDidMount() {
        this.listFilter();
        this.filterByID();
    }

    componentWillUnmount() {
        this.props.clearReducer();
        this.setState({ ...NewState });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.getAcoes() === null) {
            this.props.setAcoes(
                <NovoFluxoApp
                    type="Fab"
                    id={"fab-add-contas-pagar"}
                    className={clsx("text-white mt-12")}
                    variant="contained"
                    color="primary"
                    tipo={101}
                    get={"SEL"}
                    idpessoa={this.props.xappRouteParams.empresa}
                    iconProps={"justify-center"}
                    icon={"add"}
                    tooltip={{ "title": "Novo", "placement": "top" }}
                    showDialog={true}
                    callback={this.listFilter}
                    data={{ tipo: 14 }}
                    xappRouteParams={this.props.xappRouteParams}
                />
            );
        }

        if (!_.isEqual(prevProps.location.search, this.props.location.search)) {
            this.filterByID();
        }

        if (!_.isEqual(this.props.data, prevProps.data) && !_.isUndefined(this.props.data) && !_.isNull(this.props.data) && this.props.data.length === 1 &&
            !_.isNull(this.state.idtarefaprocessoapontamentoitem) && _.isEqual(this.props.data[0].idtarefaprocessoapontamentoitem, this.state.idtarefaprocessoapontamentoitem)) {
            this.openDialogTitulo(this.props.data[0]);
        }

        if (!_.isNull(this.props.dataBase) && !_.isEqual(this.props.dataBase, prevProps.dataBase)) {
            this.setState({
                ...this.state,
                "inicio": Helpers.GetDataFirstDayMonth("usa", this.props.dataBase),
                "termino": Helpers.GetDataLastDayMonth("usa", this.props.dataBase),
                "forceRefresh": 1
            });
        }

        if (this.state.forceRefresh === 1 && !_.isEqual(this.state.forceRefresh, prevState.forceRefresh)) {
            this.listFilter();
            this.setState({
                ...this.state,
                "forceRefresh": 0
            });
        }
    }

    filterByID = () => {
        const { search, pathname } = document.location;
        let AObj = Object.assign({}, this.state);
        if (search) {
            var AQueryParsed = queryString.parse(search);
            if (!_.isUndefined(AQueryParsed.id) && !_.isNull(AQueryParsed.id)) {
                AObj.idtarefaprocessoapontamentoitem = Number(AQueryParsed.id);
                window.history.replaceState({}, document.title, pathname);
            }
        }
        AObj.forceRefresh = 1;
        this.setState(AObj);
    };

    handleLookupPessoaFormulario = (_AValue = null) => {
        var obj = this.state;
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj.idpessoaformulario = _AValue[0].idpessoaformulario;
            obj.nome = _AValue[0].nome;
            this.setState(obj);
        }
        else {
            obj.idpessoaformulario = null;
            obj.nome = null;
            this.setState(obj);
        }
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    listFilter = (_AUseFiltro = true) => {
        const xappRouteParams = this.props.match.params;
        var AFilter = this.getFilter(_AUseFiltro);
        this.props.listPagarReceber(xappRouteParams, AFilter);
    };

    getFilter = (_AUseFiltro = true) => {
        const form = this.state;
        var AFilter = JSON.parse(JSON.stringify(parametros.filter));
        AFilter.AND[2].Valor = form.inicio + " 00:00:00";
        AFilter.AND[3].Valor = form.termino + " 23:59:59";

        if (_AUseFiltro && form.idpessoaformulario !== null && form.idpessoaformulario !== "") {
            AFilter.AND.push({ "Campo": "tarefaprocessoapontamento.idpessoaformulario", "Operador": "=", "Valor": form.idpessoaformulario });
        }

        if (_AUseFiltro && form.idtarefaprocessoapontamentoitem !== null && form.idtarefaprocessoapontamentoitem !== "") {
            AFilter.AND.push({ "Campo": "tarefaprocessoapontamentoitem.idtarefaprocessoapontamentoitem", "Operador": "=", "Valor": form.idtarefaprocessoapontamentoitem });
        }
        return AFilter;
    };

    canBeFilter = () => {
        const { inicio, termino } = this.state;
        return (
            inicio !== null && inicio !== "" &&
            termino !== null && termino !== ""
        );
    };

    openDialog = (_AValue) => {
        var obj = Object.assign({}, this.state, { rowId: null });
        obj.open = _AValue;

        if (_AValue === null) {
            obj.selecteds = "";
        }
        this.setState(obj);
    };

    openDialogGrupo = (_AValue) => {
        var obj = Object.assign({}, this.state, { rowId: null });
        obj.openGrupo = _AValue;

        if (_AValue === null) {
            obj.selecteds = "";
        }
        this.setState(obj);
    };

    handleChangeRadio = (event, item) => {
        var AState = this.state.selecteds.split(",");
        AState = AState.filter(value => value !== "");

        if (!this.isSelected(item.idtarefaprocessoapontamentoitem)) {
            AState.push(item.idtarefaprocessoapontamentoitem);
        }
        else {
            AState = AState.filter(id => id !== item.idtarefaprocessoapontamentoitem.toString());
        }
        if (AState === null) {
            AState = [];
        }
        this.setState(_.set({ ...this.state }, event.target.name, AState.join()));
    };

    isSelected = (id) => {
        return _.findIndex(this.state.selecteds.split(","), x => (x === id)) !== -1;
    };

    getIds = (_AValue) => {
        var AResponse = "";
        _AValue.forEach(item => {
            if (AResponse.length > 0) {
                AResponse = AResponse + ",";
            }
            AResponse = AResponse + item.idtarefaprocessoapontamentoitem;
        });

        return AResponse;
    };

    openDialogDetalhes = (_AValue) => {
        this.setState({ openDetalhe: _AValue, rowId: null });
    };

    openDialogTitulo = (_AValue) => {
        this.setState({ openTitulo: _AValue, rowId: null });
    };

    getIcone = (_AName) => {
        switch (_AName.toString().toLowerCase()) {
            case "a pagar":
            case "a receber": return <RiTimerLine className="list-item-icon text-20 mr-8" color="action" />;
            case "vencido": return <GiFire className="list-item-icon text-20 mr-8 text-red" />;
            case "baixado": return <MdDone className="list-item-icon text-20 mr-8 text-green" />;
            case "hoje": return <MdToday className="list-item-icon text-20 mr-8 text-blue" />;
            default: return <MdLabel className="list-item-icon text-20 mr-8" color="action" />;
        }
    };

    getColumns = (isImpressao = false) => {
        const { savePagarReceber } = this.props;
        const xappRouteParams = this.props.match.params;
        const form = this.state;
        let AArray = [
            {
                expander: true,
                width: 0,
                show: false,
                Expander: () => <div />
            },
            {
                Header: "",
                accessor: "check",
                width: 60,
                className: "justify-center",
                Cell: row => (
                    <React.Fragment>
                        {!_.isNull(row.original.idtarefaprocessoapontamentoitemgrupo) ?
                            <XAPPButton
                                tooltip={{ "title": "Agrupado", "placement": "top" }}
                                type="Icon"
                                className="p-0"
                                variant="contained"
                                color="action"
                                noHover={true}
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                }} s
                                icon={"layergroup"}
                            />
                            :
                            <Checkbox
                                className="p-0"
                                type="checkbox"
                                name="selecteds"
                                disabled={row.original.status === "cancelado"}
                                checked={form.selecteds.length > 0 && this.isSelected(row.original.idtarefaprocessoapontamentoitem)}
                                onChange={event => this.handleChangeRadio(event, row.original)}
                            />
                        }
                    </React.Fragment>
                )
            },
            {
                Header: "Ações",
                accessor: "acoes",
                width: 60,
                Cell: row => (
                    <React.Fragment>
                        {row.original.status !== "cancelado" &&
                            <XAPPButton
                                // tooltip={{ "title": "Ações", "placement": "top" }}
                                type="Icon"
                                className="p-0"
                                variant="contained"
                                color="primary"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.setState({ ...this.state, rowId: row.original.idtarefaprocessoapontamentoitem });
                                }}
                                iconProps={"justify-center text-24"}
                                icon={"arrow_down"}
                                id={"Acoes_" + row.original.idtarefaprocessoapontamentoitem}
                            />
                        }
                        <Popover
                            id="financeitoReceberMenu"
                            //anchorEl={form.menuEl}
                            style={form.rowId === row.original.idtarefaprocessoapontamentoitem && {
                                position: "absolute",
                                minWidth: "190px",
                                top: document.getElementById("Acoes_" + row.original.idtarefaprocessoapontamentoitem).getBoundingClientRect().top,
                                left: document.getElementById("Acoes_" + row.original.idtarefaprocessoapontamentoitem).getBoundingClientRect().left - 190
                            }}
                            open={form.rowId === row.original.idtarefaprocessoapontamentoitem}
                            onClose={(ev) => {
                                ev.stopPropagation();
                                this.setState(_.set({ ...this.state }, "rowId", null));
                            }}
                        >
                            {row.original.idtarefaprocessoapontamentoitemgrupo === null &&
                                <ListItem
                                    className="cursor-pointer"
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.openDialog(row.original);
                                    }}
                                >
                                    <ListItemIcon>
                                        <XAPPButton
                                            noHover={true}
                                            type="Icon"
                                            className="p-6"
                                            variant="contained"
                                            iconProps={"justify-center text-24"}
                                            icon={row.original.baixa === null ? "done" : "return"}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary={row.original.baixa === null ? "Baixar" : "Estornar"} />
                                </ListItem>
                            }
                            {row.original.baixa === null && row.original.idtarefaprocessoapontamentoitemgrupo === null &&
                                <ListItem
                                    className="cursor-pointer"
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        savePagarReceber("CANCELARITEM", row.original, xappRouteParams, this.getFilter());
                                        this.setState({ ...this.state, rowId: null });
                                    }}
                                >
                                    <ListItemIcon>
                                        <XAPPButton
                                            noHover={true}
                                            type="Icon"
                                            className="p-6"
                                            variant="contained"
                                            iconProps={"justify-center text-24"}
                                            icon={"close"}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary={"Cancelar titulo"} />
                                </ListItem>
                            }
                            {row.original.idtarefaprocessoapontamentoitemgrupo !== null &&
                                <ListItem
                                    className="cursor-pointer"
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.openDialogDetalhes(row.original);
                                    }}
                                >
                                    <ListItemIcon>
                                        <XAPPButton
                                            noHover={true}
                                            type="Icon"
                                            className="p-6"
                                            variant="contained"
                                            iconProps={"justify-center text-24"}
                                            icon={"layergroup"}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary={"Detalhes do grupo"} />
                                </ListItem>
                            }
                            <ListItem
                                className="cursor-pointer"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.openDialogTitulo(row.original);
                                }}
                            >
                                <ListItemIcon>
                                    <XAPPButton
                                        noHover={true}
                                        type="Icon"
                                        className="p-6"
                                        variant="contained"
                                        iconProps={"justify-center text-24"}
                                        icon={"edit"}
                                    />
                                </ListItemIcon>
                                <ListItemText primary={"Editar titulo"} />
                            </ListItem>
                        </Popover >
                    </React.Fragment >
                )
            },
            {
                Header: "Status",
                accessor: "status",
                width: 65,
                className: "justify-center",
                Cell: row => (
                    <div className="flex items-center">
                        {this.getIcone(row.original.status)}
                    </div>
                )
            },
            {
                Header: "Nome",
                accessor: "nome",
                className: "justify-start"
            },
            {
                Header: "Valor",
                accessor: "valortotaldescricao",
                className: "justify-end"
            },
            {
                Header: "Competência",
                accessor: "competenciadescricao",
                className: "justify-end",
                show: false
            },
            {
                Header: "Vencimento",
                accessor: "vencimentodescricao",
                className: "justify-end"
            },
            {
                Header: "Forma de pagamento",
                accessor: "idpessoaformularioformapagamentodescricao",
                className: "justify-end",
                show: true
            },
            {
                Header: "Status",
                accessor: "status",
                className: "justify-end",
                show: false
            },
            {
                Header: "Baixa",
                accessor: "baixadescricao",
                className: "justify-end",
                show: false
            },
        ];

        if (!isImpressao && _.isNull(md.mobile()) && _.isNull(md.tablet())) {
            AArray.push(AArray.splice(_.findIndex(AArray, { accessor: "acoes" }), 1)[0]);
        }

        if (isImpressao) {
            AArray.splice(_.findIndex(AArray, { accessor: "acoes" }), 1);
            AArray.splice(_.findIndex(AArray, { accessor: "check" }), 1);
            AArray.splice(_.findIndex(AArray, { accessor: "status" }), 1);
        }

        return AArray;
    };

    getBotoes = (_AIDs) => {
        const { data } = this.props;

        var verBaixa = false;
        var verGrupo = false;

        if (_AIDs.split(",").length > 1) {
            verBaixa = false;
        }
        else {
            data.forEach(item => {
                if (_AIDs.includes(item.idtarefaprocessoapontamentoitem)) {
                    if (item.baixa === null && item.idtarefaprocessoapontamentoitemgrupo === null) {
                        verBaixa = true;
                    }
                    else {
                        verBaixa = false;
                    }
                }
            });
        }
        if (_AIDs.split(",").length > 1) {
            data.forEach(item => {
                if (_AIDs.includes(item.idtarefaprocessoapontamentoitem)) {
                    if (item.baixa === null && item.idtarefaprocessoapontamentoitemgrupo === null) {
                        verGrupo = true;
                    }
                    else {
                        verGrupo = false;
                    }
                }
            });
        }

        return (
            <React.Fragment>
                {verBaixa &&
                    <XAPPButton
                        tooltip={{ "title": "Baixar", "placement": "top" }}
                        className={"p-6"}
                        type="Icon"
                        color="action"
                        icon={"cifrao"}
                        onClick={() => this.openDialog(this.state)}
                    />
                }
                {verGrupo &&
                    <XAPPButton
                        tooltip={{ "title": "Gerar grupo", "placement": "top" }}
                        className={"p-6"}
                        type="Icon"
                        color="action"
                        icon={"layergroup"}
                        onClick={() => this.openDialogGrupo(this.state)}
                    />
                }
            </React.Fragment >
        );
    };

    getExpanded = () => {
        let AResponse = {};
        const { data = null } = this.props;
        if (!_.isNull(data)) {
            data.forEach((item, x) => {
                AResponse[x] = !_.isNull(item.observacao) && item.observacao !== "";
            });
        }
        return AResponse;
    };

    pesquisar = (_AUseFiltro = true) => {
        this.listFilter(_AUseFiltro);
        if (!_.isUndefined(this.PesquisaPainel)) {
            this.PesquisaPainel.togglePainel("apagar", _AUseFiltro ? this.getCountFiltro() : 0, this.clearFiltro);
        }
    };

    clearFiltro = () => {
        this.setState(_.set({ "idpessoaformulario": null, "idtarefaprocessoapontamentoitem": null }));
        this.pesquisar(false);
    };

    getCountFiltro = () => {
        const { idpessoaformulario = null, idtarefaprocessoapontamentoitem = null } = this.state;
        let AResponse = 0;

        if (!_.isNull(idpessoaformulario)) {
            AResponse++;
        }
        if (!_.isNull(idtarefaprocessoapontamentoitem)) {
            AResponse++;
        }
        return AResponse;
    };

    render() {
        const { classes, data = null, theme } = this.props;
        const xappRouteParams = this.props.match.params;
        const form = this.state;
        return (
            <React.Fragment>
                <PesquisaPainel
                    id="apagar"
                    anchor="left"
                    onRef={instance => this.PesquisaPainel = instance}
                >
                    <div className={"flex flex-col p-12 text-center items-center"}>
                        <EmpresaPessoaApp
                            className="mb-12"
                            xappRouteParams={xappRouteParams}
                            selected={!_.isNull(form.idpessoaformulario) ? [{ ...form, id: form.idpessoaformulario }] : []}
                            label={"Pessoa"}
                            id={"LookupFiltroAReceberEmpresaPessoa"}
                            campoid={"idpessoaformulario"}
                            camponome={"nome"}
                            onChange={this.handleLookupPessoaFormulario}
                            required={true}
                            isLookup={true}
                            multiSelect={false}
                        />
                        <TextField
                            className="mb-12"
                            id="idtarefaprocessoapontamentoitem"
                            name="idtarefaprocessoapontamentoitem"
                            label="ID"
                            value={form.idtarefaprocessoapontamentoitem}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            className="mb-12"
                            id="inicio"
                            name="inicio"
                            label="Início"
                            value={form.inicio}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            className="mb-12"
                            id="termino"
                            name="termino"
                            label="Término"
                            value={form.termino}
                            onChange={this.handleChange}
                            variant="outlined"
                            type="date"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    <div className="flex p-12 gap-6">
                        <div className="flex-1" />
                        <XAPPButton
                            className="text-white"
                            label="Limpar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="close"
                            iconProps="text-20 mr-8"
                            onClick={() => this.clearFiltro()}
                        />
                        <XAPPButton
                            className="text-white"
                            label="Pesquisar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="search"
                            iconProps="text-20 mr-8"
                            onClick={() => this.pesquisar()}
                        />
                    </div>
                </PesquisaPainel>
                <DashboardFuncionalidade
                    funcionalidade={"contaspagar"}
                    data={data}
                    agrupador={"idpessoaformularioformapagamentodescricao"}
                    conteudo={"valorgrafico"}
                >

                    {!_.isUndefined(data) && !_.isNull(data) && data.length > 0 &&
                        <ImprimirApp
                            data={data}
                            key="btnImprimir"
                            id="EmpresaFinanceiroReceber"
                            label="CONTAS A PAGAR"
                            column={this.getColumns(true)}
                            className="p-6"
                            type="icon"
                            color="action"
                        />
                    }
                    {form.selecteds.length > 0 &&
                        this.getBotoes(form.selecteds)
                    }
                </DashboardFuncionalidade>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <div className="w-full flex flex-col p-12">
                        {(!_.isUndefined(data) && !_.isNull(data) && data.length > 0) ?
                            <ReactTable
                                className={clsx(classes.root, "min-w-full -striped -highlight border-0")}
                                getTrProps={(state, rowInfo) => {
                                    return {
                                        className: clsx("cursor-pointer", rowInfo && rowInfo.original.status === "cancelado" && classes.tachado),
                                        onClick: () => {
                                            if (rowInfo) {
                                                this.openDialogTitulo(rowInfo.original);
                                            }
                                        }
                                    };
                                }}
                                data={data}
                                columns={this.getColumns()}
                                SubComponent={(row) => (
                                    <div
                                        className={clsx("flex w-full py-4 px-8", theme.palette.type === "dark" ? "bg-grey-darkest" : "bg-grey-light")}
                                        style={{
                                            textIndent: 180
                                        }}
                                    >
                                        {row.original.observacao}
                                    </div>
                                )}
                                expanded={this.getExpanded()}
                                hiddenColumns={["accessor"]}
                                defaultPageSize={data.length}
                                showPagination={false}
                            />
                            :
                            <div className="flex flex-col flex-1 items-center justify-center p-16">
                                <div className="max-w-512 text-center">
                                    <FuseAnimate delay={500}>
                                        <Typography variant="h6" color="textSecondary" className="mb-16">
                                            {"Não existem registros cadastrados!"}
                                        </Typography>
                                    </FuseAnimate>
                                </div>
                            </div>
                        }
                    </div>
                </FuseAnimate>
                <EmpresaFinanceiroBaixaDialog
                    open={form.open}
                    openDialog={this.openDialog}
                    xappRouteParams={xappRouteParams}
                    parametros={parametros}
                    filter={this.getFilter()}
                />
                <EmpresaFinanceiroGrupoDialog
                    open={form.openGrupo}
                    openDialog={this.openDialogGrupo}
                    xappRouteParams={xappRouteParams}
                    parametros={parametros}
                    filter={this.getFilter()}
                />
                <EmpresaFinanceiroDetalheDialog
                    open={form.openDetalhe}
                    openDialog={this.openDialogDetalhes}
                    xappRouteParams={xappRouteParams}
                    parametros={parametros}
                    filter={this.getFilter()}
                />
                <EmpresaFinanceiroTituloDialog
                    open={form.openTitulo}
                    openDialog={this.openDialogTitulo}
                    xappRouteParams={xappRouteParams}
                    parametros={parametros}
                    filter={this.getFilter()}
                />
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        listPagarReceber: Actions.listPagarReceber,
        savePagarReceber: Actions.savePagarReceber,
        clearReducer: Actions.clearReducer,
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro, auth, fuse }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
        sistemas: auth.user.data.settings.sistemas,
        theme: fuse.settings.mainTheme,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroPagar)));
